import { createBrowserRouter } from "react-router-dom";

import App from "App";

import authenticatedRoutes from "./authenticated/authenticated.routes";
import publicRoutes from "./public/public.routes";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [...publicRoutes, ...authenticatedRoutes],
  },
]);

export default router;
